<template>
  <div>
    <ul class="images-list" :class="{'sub-page': isSubPage}">
      <li v-for="row in list" :key="row.contentItemId">
        <div class="pic-model" @click.stop="handlePreviewOpen(row)">
          <img class="pic" :src="getPictureUrl(row)"/>
          <img v-if="getVideo(row)" class="pic-play-btn" :src="playBtnPic"/>
        </div>
        <div class='content' @click='toDetails(row)'>
          <div class='list-tags gap-mini'>
            <div v-for="tag in row.fileItemTags" :key="tag.tagId" class='tag'>{{tag.tagName}}</div>
          </div>
          <div class='list-title fs-1'>{{row.newsTitle}}</div>
          <div class='list-desc' :class="{'h-auto':row.isFold}">
            <div class='inner'>{{row.newsSummary}}</div>
            <div v-show="!row.isFold" class='mask'></div>
            <div class='btn-fold' @click.stop='handleFold(row)'>展开更多</div>
          </div>
          <div v-if="row.fileLists.length>0" class='list-btns'>
            <button class='mc-common-btn w-all' @click.stop='handleDownload(row)'>高清图片下载</button>
          </div>
        </div>
      </li>
    </ul>

    <preview-layer v-if="picPreviewShow" @close="picPreviewShow=false">
      <template slot="context">
        <img class="pic" :src="currentUrl"/>
      </template>
    </preview-layer>

    <preview-layer v-if="videoPreviewShow" @close="videoPreviewShow=false">
      <template slot="context">
        <video controls
               controlsList="nodownload"
               ref="downloadVideo"
               playsinline
               x-webkit-airplay
               x5-video-player-type="h5"
               x5-videoplayer-fullscreen
               webkit-playsinline
               :src="currentUrl"
               :poster="currentPoster"
               x5-video-orientation='portraint'
               style='object-fit:fill;'
               width='375px'
               height='211px'></video>
      </template>
    </preview-layer>

    <message-box v-if="registerSuccessMsgShow" @close="registerSuccessMsgShow=false">
      <template slot="context">注册待审中<br/>我们将尽快审核您的申请，<br/>并告诉您审核结果</template>
    </message-box>
  </div>
</template>

<script>
import {isWechatBrowser,downloadUrlFile} from "@/utilities/tools";
import PreviewLayer from "./PreviewLayer";
import MessageBox from "../../components/MediaCenter/MessageBox";
export default {
  name: "ImagesList",
  components: {PreviewLayer,MessageBox},
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    isSubPage: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      picPreviewShow: false,
      videoPreviewShow: false,
      currentUrl: null,
      currentPoster: null,
      playBtnPic: require("@/assets/MediaCenter/playBtn.png"),
      registerSuccessMsgShow: false
    }
  },
  methods: {
    toDetails({contentItemId}){
      this.$router.push({
        name: "DownloadDetails",
        params: {
          id: contentItemId
        }
      })
    },
    getPictureUrl({newsPictureUrl, fileLists}) {
      let file = fileLists[0];
      let imgUrl = null;
      if(file && file.reviewImageUrl) {
        imgUrl = file.reviewImageUrl;
      } else if(file && file.videoBgImageUrl) {
        imgUrl = file.videoBgImageUrl;
      } else {
        imgUrl = newsPictureUrl;
      }
      return imgUrl;
    },
    getVideo({fileLists}) {
      return fileLists[0] && fileLists[0].videoBgImageUrl;
    },
    handleDownload(row) {
      let fileUrl = row.fileLists[0].fileUrl;
      let fileName = row.fileLists[0].fileName;
      let isAllowDownload = row.fileLists[0].isAllowDownload;
      if(localStorage.getItem('dUserToken')) {
        if(!isAllowDownload) {
          this.registerSuccessMsgShow = true;
          return;
        }
      } else {
        const redirectUrl = encodeURIComponent(this.$route.path);
        this.$router.push("/Rccl.CustomPage/MediaCenter/MediaLogin?redirectUrl="+redirectUrl);
        return;
      }
      if(!isWechatBrowser()) {
        downloadUrlFile(fileUrl, fileName, this.$loading);
      }
    },
    handleFold(row) {
      row.isFold =! row.isFold;
    },
    handlePreviewOpen({newsPictureUrl, fileLists}) {
      let file = fileLists[0];
      if(file.reviewImageUrl) {
        this.currentUrl = file.reviewImageUrl;
        this.picPreviewShow = true;
      } else if(file.videoBgImageUrl) {
        this.currentPoster = file.videoBgImageUrl;
        this.currentUrl = file.videoLink;
        this.videoPreviewShow = true;
      } else {
        this.currentUrl = newsPictureUrl;
        this.picPreviewShow = true;
      }
    }
  }
}
</script>

<style lang="less" scoped>
/*图片列表*/
.images-list {
  display: grid;
  justify-content: space-between;
  grid-template-columns: 156.5px 156.5px;
  margin-top: 11px;
  &.sub-page {
    margin-top: 0;
    & li {
      padding: 21px 0 0;
    }
  }
  & li {
    padding: 18px 0;
    & .pic-model {
      position: relative;
      width: 156.5px;
      height: 156.5px;
      overflow: hidden;
      & .pic {
        position: absolute;
        top: 0;
        left: 50%;
        width: 150%;
        transform: translateX(-50%);
        height: auto;
      }
      & .pic-play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 1;
        width: 40px;
        height: 40px;
        opacity: .7;
      }
    }
    & .content {
      padding: 0 5px;
    }
  }
}
</style>
